import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			heHubPulsarsDiscoveryNeutronImgTxtSectionColLeftCls: string;
			heHubPulsarsDiscoveryNeutronImgTxtSectionColRightCls: string;
		}
	},

	slug: string
}

class Neutron extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('He Hub Pulsars Discovery Neutron Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubPulsarsDiscoveryNeutronImgTxtSectionColLeftCls || '', 'he_hub_pulsars_discovery_neutron', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubPulsarsDiscoveryNeutronImgTxtSectionColRightCls || '', 'he_hub_pulsars_discovery_neutron', { animCls: 'animate__fadeInRight25P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Neutron;